module.exports = __webpack_public_path__ + "img/vertical_7_5_8017.b83dd888.png";